const hardcodedItems = [
    {
        id: "1",
        image: "https://kr.louisvuitton.com/content/dam/lv/online/high-end/wolv/fashion-shows/M_Fa_Show_FW24.html/jcr:content/assets/details/10_MENS_FW24_SHOW_BACKDROP_VISUALS_05_3_LV-COM_DI3_2048x1152.jpg",
        brand: "Louis Vuitton",
    },
    {
        id: "2",
        image: "https://d2dalh4h075hii.cloudfront.net/wp-content/uploads/2024/02/dolce-and-gabbana-women-fall-winter-24-25-fashion-show-featured-image-1.jpg",
        brand: "Dolce & Gabbana",
    },
    {
        id: "3",
        image: "https://imgdev.edge.regiongold.com/dynamic/2a79/i2PABy58uUwZgy71lhRPTWJAoYywqvWxW9Qf3ggTQXEEzdgliLd125RHC90Af8tZIL3OyN4eB2lCTIPgDjP5OlXn+Gt4+1OpiqHyoX9g9Yy3jXMbgzez_7CmnbJ0NpD4WhTUE7PBcPX242TBVYxeTCO5+K059y8Ze4oUn1dDBsY+A48PfwfwFV0EECkUdQV20TchTNiISgEypCT_d1tcbmrKhPShtpmaUtjbLv71F0KGEJ2AGYfaVNAzeaMI5LdKHnVpUge1WWSc1zuF4JZpkQ==/Full_Bleed_-_Details_Section_Hero_-_Desktop.jpg",
        brand: "GUCCI",
    },
    {
        id: "4",
        image: "https://www.dior.com/couture/var/dior/storage/images/folder-media/folder-videos/folder-defiles/folder-defile-homme-ete-2025/dior_show_men_ss25_finale_desktop/44234602-1-fre-FR/dior_show_men_ss25_finale_desktop.jpg?imwidth=1850",
        brand: "DIOR",
    },
    {
        id: "5",
        image: "https://www.prada.com/content/dam/pradanux/home_page/2024/06/CO_conchiglie/summer_collection/woman/banner_DT.jpg/_jcr_content/renditions/cq5dam.web.1664.1664.webp",
        brand: "PRADA",
    },
    {
        id: "6",
        image: "https://balenciaga.dam.kering.com/m/5b56fc63213014a1/Large-HP_DK_INSTITUTIONAL_BAG_CAMPAIGN_RODEO_04_2600x1300_2x1.jpg",
        brand: "Balenciaga",
    },
    {
        id: "7",
        image: "https://www.miumiu.com/content/dam/miumiu/2024/000_homepage/05/CO_Ete/ww/banner_cressi_2/banner_DT_3.jpg/jcr:content/renditions/cq5dam.web.1440.709.webp",
        brand: "MIU MIU",
    },
    {
        id: "8",
        image: "https://bottega-veneta.dam.kering.com/m/7402b283c80d45c6/Large-BV_SUMMER-SOLSTICE-24_MAIN_Digital-Template-P22-B19.jpg",
        brand: "Bottega Veneta",
    },
    {
        id: "9",
        image: "https://www.thombrowne.com/BWStaticContent/26000/e4913cd8-c0e7-47a0-9f00-1df49b6b4194_home-plp-01-desktop.jpg",
        brand: "Thom Browne",
    },
    {
        id: "10",
        image: "https://www.chanel.com/images/q_auto:good,f_auto,fl_lossy,dpr_1.1/w_1600/FSH-1714812778852-desktopheadershow.jpg",
        brand: "CHANEL",
    },
];
export default hardcodedItems;
